
<div *ngIf="( line != null)">

<app-banners secaoUrl="linhas" urlMobile="{{line.mobile_url}}" urlDesktop="{{line.desktop_url}}"></app-banners>

<div  style="background-color: #F1F1F1;">
  <div class="container pt-5 pb-5">

      <div class="footer-gray-light">
        <a href="/linhas"> Linha de Produtos </a>
        <span class="arrow-bread-crumb" *ngIf="parentSlug"> >> </span>
        <a *ngIf="parentSlug" href="/linhas/{{parentSlug.slug}}"> {{parentSlug.nome}} </a>
      </div>
      <div class="title"> <span>{{line?.nome}}</span></div>
      <div class="description">{{ line?.descricao }}</div>
  </div>
</div>
<div class="container-md" style="min-height: 100vh;" >
  <div class="l-cards" *ngIf="line.categorias && !slugToSearch">
    <div *ngFor="let res of line?.categorias">
      <a style="text-decoration: none; cursor: pointer;" href="{{res.link}}">
        <div class="teste">
          <div class="card-linhas">
            <img src="{{ res.cover_url ? res.cover_url : 'assets/icons/Logo.png'}}" alt="">
          </div>
          <div>
            <p class="text-center mt-2 title-linhas">{{ res.nome }}</p>
          </div>
        </div>
      </a>
    </div>
    <div *ngIf="line?.length <= 0" class="w-100" >
      <p class="text-center">
      Desculpe, nenhuma linha encontrada! Produto linhas</p>
    </div>
  </div>
  <div class="container-md d-flex flex-wrap">
    <div *ngFor="let tag of tags " class="">
      <div *ngIf="tag.hasProducts">
        <div [ngClass]="{'active': tag.slug == slugToSearch}" class="border rounded p-2 m-2 tag" routerLink="{{tag.link}}">
          <span >
            {{tag.nome}}
          </span>

      </div>
      </div>
    </div>
  </div>
  <div *ngIf="products && products.length && !loadingProducts" class="container pt-2">
    <app-cards [listProducts]="products"></app-cards>
  </div>
  <div *ngIf="loadingProducts" class="w-100 d-flex justify-content-center align-items-center mt-5" style="height: 50vh;">
    <span style="margin-right: 5px;">Carregando</span>
    <mat-spinner [diameter]="30"></mat-spinner>
  </div>
</div>

</div>
 <div style="height: 100vh;" *ngIf="line == null">
 </div>
